import { ChipField, ReferenceArrayField, SingleFieldList } from "react-admin";
import { DISCOUNT_COUPON_APPLIES_TO } from "../enums/DiscountCouponAppliesToType";

const DynamicReferenceField = ({ record }) => {
  if (!record || !record.appliesTo) return null;

  const { type } = record.appliesTo;

  switch (type) {
    case DISCOUNT_COUPON_APPLIES_TO.RESTAURANT:
      return (
        <ReferenceArrayField
          label="Restaurantes"
          reference="restaurants"
          source="appliesTo.restaurants"
          record={record}
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
      );
    case DISCOUNT_COUPON_APPLIES_TO.PRODUCT:
      return (
        <ReferenceArrayField
          label="Productos"
          reference="products"
          source="appliesTo.products"
          record={record}
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
      );
    case DISCOUNT_COUPON_APPLIES_TO.PLACE_TYPE:
      return (
        <ReferenceArrayField
          label="Tipos de lugar"
          reference="place-types"
          source="appliesTo.placeTypes"
          record={record}
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
      );
    case DISCOUNT_COUPON_APPLIES_TO.ANY:
      return <span>Cualquiera</span>;
    default:
      return null;
  }
};

export default DynamicReferenceField;
